export default __webpack_public_path__ + "static/media/pickImage.71cf45f4.svg";